export abstract class CelumDialogConfiguration {
  public color?: string;
  public openedInDialogOutlet?: boolean;

  constructor(public moduleId: string) {}
}
